import * as React from "react";
const SvgFiRrUserPilot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-pilot_svg__a)">
      <path
        fill="#062147"
        d="M5.208 5.604 6 6v2c0 3.31 2.69 6 6 6s6-2.69 6-6V6l.793-.396a2.184 2.184 0 0 0-.38-4.055L13.698.21a7 7 0 0 0-3.396 0L5.587 1.55a2.185 2.185 0 0 0-.38 4.055M16 8c0 2.206-1.794 4-4 4s-4-1.794-4-4v-.39c.978.207 2.296.39 4 .39s3.022-.183 4-.39zM9.5 3.5a1 1 0 0 1 1.372-.343L12 3.834l1.128-.677a1 1 0 1 1 1.029 1.715l-1.643.985a1 1 0 0 1-1.03 0l-1.642-.985A1 1 0 0 1 9.499 3.5m11.492 19.376a1 1 0 1 1-1.984.248c-.416-3.327-2.78-5.656-6.008-6.056V23a1 1 0 1 1-2 0v-5.932c-3.227.4-5.592 2.73-6.008 6.056a1.01 1.01 0 0 1-1.116.868 1 1 0 0 1-.868-1.116C3.588 18.238 7.285 15 12 15s8.413 3.238 8.992 7.876"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-pilot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserPilot;
